import { CssBaseline } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import { ucamTheme, loadFonts } from "@ucam.uis.devops/mui-theme";

loadFonts()

import ReactDOM from 'react-dom/client';

import { StrictMode } from "react";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App';


const queryClient = new QueryClient();

async function prepare() {
  if (import.meta.env.DEV && import.meta.env.VITE_MOCK_API === 'true') {
    const { worker } = await import('./mocks/browser');
    await worker.start();
  }
}

prepare().then(() => {
  const containerEl = document.getElementById('root');
  if(containerEl){
    const root = ReactDOM.createRoot(containerEl)
    root.render(
      <StrictMode>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider theme={ucamTheme}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </QueryClientProvider>
      </StrictMode>
    );
  }

});
